import styles from "./index.module.scss";
import classes from "classnames";
export interface MembershipBenefitsProps {
  className?: string;
  benefits: string[];
  name: string;
}
const MembershipBenefits = ({
  className,
  name,
  benefits = [],
}: MembershipBenefitsProps) => {
  return (
    <div className={classes(styles.membershipBenefits, className)}>
      <div className={styles.header}>
        <div className={styles.tag}>
          <div className={styles.content}>{name}</div>
        </div>
        <div className={styles.title}>会员权益</div>
      </div>
      <div className={styles.body}>
        {benefits.map((b, i) => (
          <div className={styles.item} key={i}>
            <div className={styles.icon} />
            <div className={styles.text}>{b}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipBenefits;
